"use client";

import { BSRCheckOutline } from "./bsr/BSRCheckOutline";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { CheckOutline as LegacyCheckOutline } from "./legacy/CheckOutline";

export const CheckOutline = createBSRExperimentIcon(
  LegacyCheckOutline,
  BSRCheckOutline
);
